import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from './useAuth';
import { DEFAULT_LOCALIZATION, normalizeLocalization, translate } from '../lib/localization';
import { setFormatterLocalization } from '../utils/formatters';

const LocalizationContext = createContext({
  settings: DEFAULT_LOCALIZATION,
  loading: false,
  refresh: async () => {},
  t: (key) => key,
});

export function LocalizationProvider({ children }) {
  const { perfil } = useAuth();
  const [settings, setSettings] = useState(DEFAULT_LOCALIZATION);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!perfil?.oficina_id) {
      setSettings(DEFAULT_LOCALIZATION);
      setFormatterLocalization(DEFAULT_LOCALIZATION);
      return;
    }

    setLoading(true);
    try {
      const { data, error } = await supabase
        .from('oficinas')
        .select('pais_codigo,idioma,locale_codigo,moeda,fuso_horario,sistema_medidas,formato_data')
        .eq('id', perfil.oficina_id)
        .maybeSingle();

      if (error) throw error;
      const next = normalizeLocalization(data || {});
      setSettings(next);
      setFormatterLocalization(next);
      document.documentElement.lang = next.language;
    } catch (error) {
      console.warn('Preferencias regionais indisponiveis; usando padrao.', error);
      setSettings(DEFAULT_LOCALIZATION);
      setFormatterLocalization(DEFAULT_LOCALIZATION);
    } finally {
      setLoading(false);
    }
  }, [perfil?.oficina_id]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const value = useMemo(
    () => ({ settings, loading, refresh, t: (key) => translate(settings.language, key) }),
    [settings, loading, refresh],
  );
  return <LocalizationContext.Provider value={value}>{children}</LocalizationContext.Provider>;
}

export function useLocalization() {
  return useContext(LocalizationContext);
}
